'use client'
import { useEffect, useRef} from "react";
import {easeOut, motion, MotionValue, useAnimate, useScroll, useSpring, useTransform} from "framer-motion";



function useParallaxValue(value: MotionValue<number>, distance: number) {
  const v = useTransform(value, [0, 1], [distance, 0 ], {ease: easeOut});
  return useSpring(v, { stiffness: 100, damping: 30, bounce:0, mass: 1 });
}

export const Parallax = ({children}: {children: React.ReactNode}) => {
  const container = useRef(null);
  const {scrollYProgress} = useScroll({
    target: container,
    offset: ['start 70%', 'start 20%']
  });
  const y = useParallaxValue(scrollYProgress, 100 );

  return <motion.div ref={container} style={{y}}>
          {children}
        </motion.div>;
}

export function useParallax<T extends HTMLElement>(){
  const ref = useRef<T>(null);
  const {scrollYProgress, scrollXProgress} = useScroll({
    target: ref,
    offset: ['start 70%', 'start 20%']
  });
  const y = useParallaxValue(scrollYProgress, 100 );
  const x = useParallaxValue(scrollXProgress, 100 );
  useEffect(() => {
    y.on('change', () => {
      ref.current!.style.transform = "translateY("+y.get()+"px)";
    });
    x.on('change', () => {
      ref.current!.style.transform = "translateY("+x.get()+"px)";
    });
    return () => {
      x.destroy();
      y.destroy();
    }
  }, [ref, y, x]);
  return ref;
}
